<template>
    <div class="tx-product-border-wrapper">
        <div class="tx-product-border" data-product-preview>
            <slot></slot>
        </div>
        <div class="tx-product-border-woodenstick-wrapper">
            <span class="tx-product-border-woodenstick"></span>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'StudentPosterBorder',
    }
</script>

<style scoped lang="scss">
    .tx-product-border {
        background: white;
        border: none;
        box-shadow: none;
        height: 100%;
        padding: 0;
        position: relative;
        overflow: hidden;
        &-wrapper {
            /*padding-bottom: 140px;*/
        }
    }
    .tx-product-border-woodenstick {
        background-image: url("../../../../tx-renderer-utils/images/wooden-stick.png");
        background-repeat: no-repeat;
        background-size: contain;
        display: block;
        height: 196px;
        margin: 0 auto;
        width: 62px;
        &-wrapper {
            height: 200px;
            position: relative;
            width: 100%;
            text-align: center;
        }
    }
</style>

